import { render, staticRenderFns } from "./u-footer-foot-basic.vue?vue&type=template&id=32d03cd2&scoped=true&"
import script from "./u-footer-foot-basic.vue?vue&type=script&lang=js&"
export * from "./u-footer-foot-basic.vue?vue&type=script&lang=js&"
import style0 from "./u-footer-foot-basic.vue?vue&type=style&index=0&id=32d03cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d03cd2",
  null
  
)

export default component.exports